//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceStatus } from './Enums';

export class CalendarAttendanceDisplayItem extends ItemBase {
    Absent: boolean = false;
    AttendanceStatus: AttendanceStatus = AttendanceStatus.Unrecorded;
    Editable: boolean = false;
    EventID: string | null = null;
    ID: string | null = null;
    StudentFirstName: string | null = null;
    StudentFullName: string | null = null;
    StudentID: string | null = null;
    StudentLastName: string | null = null;

    constructor(initializer?: Partial<CalendarAttendanceDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarAttendanceDisplayItem";
}
